const article = {
    id: 'raw-qc-performance',
    title: 'Raw QC performance',
    summary: 'See who is working Raw QC today, what they are on, and how long tasks have been open.',
    publishedAt: '2026-09-22',
    tags: ['raw qc', 'sidebar'],
    sections: [
        {
            type: 'paragraph',
            text: 'Raw QC Performance shows the current session’s Raw QC work by person: status, the SKU they are on, and how long it has been open. The session day runs from 6:00 am IST to 6:00 am IST the next morning.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it during a shoot day to spot people who are idle, on hold, or stuck on one SKU.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Raw QC Performance in the sidebar.',
                'Leave the client filter on All clients, or pick one client code.',
                'Read the summary counts, then the table for each person’s current task.',
                'On hold rows show the SKU and the time the hold runs until.',
            ],
        },
        {
            type: 'note',
            text: 'Work finished after midnight and before 6:00 am still belongs to the previous session day.',
        },
    ],
};

export default article;
